export default __webpack_public_path__ + "static/media/eye.44df0678.svg";